// extracted by mini-css-extract-plugin
export default {"heading":"pC-z","corrected":"qC-z","redirectVerbiageContainer":"rC-z","redirectVerbiageText":"sC-z"};